<div
  class="verify-page page-wrapper page-wrapper--fullscreen-min page-wrapper--column"
>
  @if (vm().authForm?.organizationLogo; as logo) {
    <fmnts-scale-image [image]="logo" horizontalAlignment="center" />
  }

  <div class="verify-form__wrapper">
    @if (vm().errors; as error) {
      @if (error._tag === 'ClientTimeoutError') {
        <fmnts-empty-state>
          <fmnts-empty-state-visual>
            <fa-icon [icon]="sharedUi.timeout.icon" />
          </fmnts-empty-state-visual>
          <fmnts-empty-state-title>
            {{ sharedUi.timeout.title | translate }}
          </fmnts-empty-state-title>
          <fmnts-empty-state-description>
            {{ sharedUi.timeout.description | translate }}
          </fmnts-empty-state-description>
        </fmnts-empty-state>
      } @else {
        <span>{{ errorToString(error).text | translate }}</span>
      }
    } @else if (vm().authForm) {
      <router-outlet />
    }
  </div>
</div>
